import React, { Children, Fragment } from 'react';
import { GridView, defaultConfig } from './GridView';
import { times } from '../../../../play-core/utils/times';
import { useAnalyticsDispatch } from '../../analytics/AnalyticsContext';
import { useMediaQuery } from '../../hooks/use-media-query';
import { LoadMore } from '../LoadMore/LoadMore';
import { AspectPlaceholder } from '../Teaser/Placeholder/AspectPlaceholder';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SmartGridView = ({
  children,
  loadMore,
  canLoadMore,
  analyticsTitle,
  config = defaultConfig
}) => {
  const analytics = useAnalyticsDispatch();
  const [, smallConfig] = config[0];
  const activeConfig = useMediaQuery(config, smallConfig);
  const childrenArray = Children.toArray(children);
  const end = canLoadMore ? childrenArray.length - childrenArray.length % activeConfig.itemCount : childrenArray.length;
  const visibleChildren = childrenArray.slice(0, end);
  const isEmpty = visibleChildren.length === 0 || !visibleChildren;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(GridView, {
      config: config,
      children: isEmpty ? /*#__PURE__*/_jsx(Fragment, {
        children: times(20, index => /*#__PURE__*/_jsx(AspectPlaceholder, {
          aspectRatio: 16 / 9
        }, index))
      }) : visibleChildren
    }), canLoadMore && loadMore && /*#__PURE__*/_jsx(LoadMore, {
      onClick: () => {
        loadMore();
        analytics({
          type: 'click-event',
          name: 'LoadMoreClick',
          value1: window.document.title,
          value2: analyticsTitle
        });
      }
    })]
  });
};